export default "__VITE_ASSET__jT86UORx__"